export default "__VITE_ASSET__DfIelXhR__"